<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Solicitar Renuncia al Fondo de Ahorro" description="" />
      <RenounceSaving/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import RenounceSaving from '@/components/RenounceSaving/RenounceSaving.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {

    }
  },
  name: 'RenounceSavingView',
  components: {
    Header,
    RenounceSaving,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>